import classesCss from './BasicFormInput.module.css';

const BasicFormInput = ({label,
	register,
	required=true,
	css="",
	dropdown=false,
	options=[],
	area=false}) => {
	console.log(register);

	let element = "";

	if (area) {
		element = <textarea rows={10} cols={1} style={{
			maxHeight: "300px",
			minHeight: "300px",
		}} {...register(label, {
			required,
		})}/>
	} else if (dropdown) {
		element = <select {...register(label, {
			required,
		})} defaultValue={options[0]}>
			{
				options.map((item, index) => {
					return <option key={index}>{item}</option>
				})
			}
		</select>
	} else {
		element = <input {...register(label, {
			required,
		})}/>
	}
	return (
		<div className={`${css}`}>
			<div style={{display: 'flex'}}>
				<p style={{marginLeft:'0px'}}>{label}</p>
				{required ? <p style={{color: 'orange', marginLeft: "10px"}}>*</p> : null}
			</div>
			{
				element
			}
		</div>
	);
};

export default BasicFormInput
